import React from 'react';
import { ActivityIndicator, Button, Icon } from '@fourthwall/components';
import { FilterIcon } from '@fourthwall/icons';
import * as S from './AnalyticsFiltersButton.styled';
export const AnalyticsFiltersButton = ({ isActive, onClick }) => {
    return (React.createElement(S.Container, null,
        React.createElement(Button, { leftIcon: React.createElement(Icon, { component: FilterIcon, height: 18 }), label: "Filters", appearance: "secondary", size: "small", onClick: onClick }),
        isActive && (React.createElement(S.ActivityIndicatorWrapper, null,
            React.createElement(ActivityIndicator, null)))));
};
